import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import RadioBtn from "components/Custom/RadioBtn";
import Loader from "components/Custom/Loader";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";

import { NOTIFY, DEFAULTS } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  SUCCESS,
  WARNINGS,
  LABELS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { ApiMasters } from "apihandlers//masters/masters";
import { ApiGeography } from "apihandlers/geography";

const ApiMastersHandler = new ApiMasters();
const ApiGeographyHandler = new ApiGeography();

const RouteExpense = (props: any) => {
  const { setDashMenu } = props;

  const expTypeRef: any = useRef(null);
  const routeRef: any = useRef(null);

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [expTypes, setExpTypes] = useState<any>(null);
  const [routes, setRoutes] = useState<any>(null);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mandatoryResults, setMandatoryResults] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getCharges();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await ApiMastersHandler.getRouteExpenses(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getRouteExpenses:", error);
    }
  };

  const getCharges = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    ApiMastersHandler.getCharges(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setExpTypes(list);
        getRoutes();
      }
    });
  };

  const getRoutes = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    ApiGeographyHandler.getRoutes(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.routeDetail,
          };
        });
        setRoutes(list);
        getRows();
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "routeDetail",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROUTE,
      width: "30%",
    },
    {
      key: "expenseType",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EXPENSETYPE,
      width: "20%",
    },
    {
      key: "expenseAmount",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AMMOUNT,
      width: "20%",
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "10%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageRecord = () => {
    const routeId = routeRef.current.selectedValue.id;
    const expenseTypeId = expTypeRef.current.selectedValue.id;
    const expenseAmount = (
      document.getElementById("expenseAmount") as HTMLInputElement
    ).value.trim();
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    // if (!expenseAmount) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!routeId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!expenseTypeId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }
    // if (!selectBtnValue) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.MANDATORY);
    //   return;
    // }

    let errors = [];
    if (!routeId) {
      errors.push({
        id: "routeId",
        msg:
          "<span class='bold'>" +
          LABELS.ROUTE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!expenseTypeId) {
      errors.push({
        id: "expenseTypeId",
        msg:
          "<span class='bold'>" +
          LABELS.EXPENSETYPE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (expenseAmount == "") {
      errors.push({
        id: "expenseAmount",
        msg:
          "<span class='bold'>" +
          LABELS.AMMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!active) {
      errors.push({
        id: "activeStatus",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      routeId,
      expenseTypeId,
      expenseAmount,
      actualRoute: "true",
      activeStatus: selectBtnValue.toString(),
    };
    setIsSubmit(true);
    ApiMastersHandler.manageRouteExpense(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("SelectedRow", selectedRow);
  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.ROUTE_EXPENSE}</li>
        </ul>
        <h4>{TITLES.ROUTE_EXPENSE}</h4>
        <p className="SubTitles">{SUB_TITLES.ROUTE_EXPENSE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.ROUTE_EXPENSE}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.ROUTE_EXPENSE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.ROUTE_EXPENSE + ": " + selectedRow.routeDetail
              : "Add New " + LABELS.ROUTE_EXPENSE
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup red">
            <label>
              {LABELS.ROUTE}
              {<span className="red">{" *"}</span>}
            </label>
            <AutoComplete
              list={routes}
              childRef={routeRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.routeId,
                      label: selectedRow.routeDetail,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width45 red">
              <label>
                {LABELS.EXPENSETYPE}
                {<span className="red">{" *"}</span>}
              </label>
              <AutoComplete
                list={expTypes}
                childRef={expTypeRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.expenseTypeId,
                        label: selectedRow.expenseType,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width45 red">
              <TxtRow
                id={"expenseAmount"}
                label={LABELS.AMMOUNT}
                type={"number"}
                required={true}
                defaultValue={
                  selectedRow.id
                    ? Number(selectedRow.expenseAmount).toString()
                    : ""
                }
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="formGroup red">
            <label>
              {LABELS.ACTIVE_STATUS} {<span className="red">*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
                // loading={isSubmit}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(RouteExpense);
